import { OfferEntryData, GridRow, DataRow } from '../../../core/models/offerEntryData';

export class CellSelection {
    gridRowId: string;
    subrow: number;
    firstColumn: number;
    lastColumn: number;
    canEdit: boolean;
    private hasEdits: boolean;
    //initialValue: number;
    firstSelectedCellColumn: number;
    firstSelectedCellGridRowId: string;
    disableClear: boolean = false;

    localClipboard: number[] = [];


    public isCellSelected(gridRowId: string, subrow: number, column: number): boolean {
        if (gridRowId == this.gridRowId && subrow == this.subrow && column >= this.firstColumn && column <= this.lastColumn) {
            return true;
        } else {
            return false;
        }
    }

    public clearSelection() {
        if (!this.disableClear) {
            this.gridRowId = '';
            this.subrow = -1;
            this.firstColumn = -1;
            this.lastColumn = -1;
        }
    }

    public selectCell(offerEntryData: OfferEntryData, gridRowId: string, subrow: number, column: number, isEditable: boolean) {
        this.gridRowId = gridRowId;
        this.subrow = subrow;
        this.firstColumn = column;
        this.lastColumn = column;
        this.canEdit = isEditable;
        this.firstSelectedCellColumn = column;
        this.firstSelectedCellGridRowId = gridRowId;
        this.hasEdits = false;
        //this.initialValue = offerEntryData.gridRows[gridRowId].dataRows[subrow].dataValues[column];
    }

    extendSelectionToColumn(gridRowId: string, subrow: number, column: number) {
        if (gridRowId == this.firstSelectedCellGridRowId) {
            let start = column;
            let finish = this.firstSelectedCellColumn;
            if (column > this.firstSelectedCellColumn) {
                start = this.firstSelectedCellColumn;
                finish = column;
            }
            this.selectCells(start, finish);
        }
    }

    public selectCells(firstColumn: number, lastColumn: number) {
        this.firstColumn = firstColumn;
        this.lastColumn = lastColumn;
    }

    public isMultiSelected() {
        if (this.firstColumn != this.lastColumn) {
            return true;
        } else {
            return false;
        }
    }

    public isEditable() {
        return this.canEdit;
    }

    public hasClipboardData() {
        return this.localClipboard.length > 0;
    }

    public setSelection(offerEntryData: OfferEntryData, newValue: number) {
        for (let gridRow of offerEntryData.gridRows) {
            for (var subRow: number = 0; subRow < 4; subRow++) {
                for (var column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                    if (this.isCellSelected(gridRow.id, subRow, column) == true) {
                        gridRow.dataRows[subRow].dataValues[column] = newValue;
                        gridRow.dataRows[subRow].roundedDataValues[column] = newValue;  // note we can't round this here as they might be still typing
                        //gridRow.dataRows[subRow].dataStaus[column] = 'EDITING';
                        // console.log('setting ' + newValue + ' to ' + offerEntryData.intervalIds[column]);
                    }
                }
            }
        }
    }

    public updateRawFromRoundedSelection(offerEntryData: OfferEntryData) {
        for (let gridRow of offerEntryData.gridRows) {
            for (var subRow: number = 0; subRow < 4; subRow++) {
                for (var column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                    if (this.isCellSelected(gridRow.id, subRow, column) == true) {
                        if (this.round(gridRow.dataRows[subRow].dataValues[column]) != gridRow.dataRows[subRow].roundedDataValues[column]) {
                            gridRow.dataRows[subRow].dataValues[column] = gridRow.dataRows[subRow].roundedDataValues[column];
                        }
                    }
                }
            }
        }
    }

    // set a flag to show an edit has occurred
    public setEdited() {
        this.hasEdits = true;
    }

    public isEdited(): boolean {
        return this.hasEdits;
    }

    public clearEdits() {
        this.hasEdits = false;
    }

    public getSelection(offerEntryData: OfferEntryData): any {
        let selectedGridRow: GridRow;
        let row: number;
        const cols: number[] = [];
        const values: number[] = [];
        for (let gridRow of offerEntryData.gridRows) {
            for (let subRow: number = 0; subRow < 4; subRow++) {
                for (let column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                    if (this.isCellSelected(gridRow.id, subRow, column) === true) {
                        if (selectedGridRow === undefined) {
                            selectedGridRow = gridRow;
                            row = subRow;
                        }
                        cols.push(column);
                        var value: number = gridRow.dataRows[subRow].dataValues[column];
                        if (!value) {
                            value = 0;
                        }
                        values.push(value);
                    }
                }
            }
        }
        return {gridRow: selectedGridRow, row: row, cols: cols, values: values};
    }

    public adjustSelection(offerEntryData: OfferEntryData, amount: number) {
        for (let gridRow of offerEntryData.gridRows) {
            for (var subRow: number = 0; subRow < 4; subRow++) {
                for (var column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                    if (this.isCellSelected(gridRow.id, subRow, column) == true) {
                        gridRow.dataRows[subRow].dataValues[column] = +gridRow.dataRows[subRow].dataValues[column] + amount;
                        gridRow.dataRows[subRow].roundedDataValues[column] = this.round(gridRow.dataRows[subRow].dataValues[column]);
                    }
                }
            }
        }
    }

    round(num: number): number {
        if (num) {
            return Math.round(num);
        } else {
            return num;
        }
    }

    public pasteIntoGrid(offerEntryData: OfferEntryData) {
        var clipboardIx = 0;
        var pasting = false;
        if (this.localClipboard.length >= 0) {
            for (let gridRow of offerEntryData.gridRows) {
                for (var subRow: number = 0; subRow < 4; subRow++) {
                    for (var column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                        if (this.isCellSelected(gridRow.id, subRow, column) == true) {
                            pasting = true;
                        }
                        if (pasting && (clipboardIx < this.localClipboard.length) && gridRow.dataRows[subRow].isEditable) {
                            var valueToPaste = this.localClipboard[clipboardIx++];
                            gridRow.dataRows[subRow].dataValues[column] = valueToPaste;
                            gridRow.dataRows[subRow].roundedDataValues[column] = this.round(valueToPaste);
                            this.extendSelectionToColumn(gridRow.id, subRow, column);
                        }
                        if (pasting && (column == offerEntryData.columnHeaders.length - 1)) {
                            return;
                        }
                    }
                }
            }
        }
    }

    public copySelection(offerEntryData: OfferEntryData) {
        var values: number[] = [];
        for (let gridRow of offerEntryData.gridRows) {
            for (var subRow: number = 0; subRow < 4; subRow++) {
                for (var column: number = 0; column < offerEntryData.columnHeaders.length; column++) {
                    if (this.isCellSelected(gridRow.id, subRow, column) == true) {
                        values.push(gridRow.dataRows[subRow].dataValues[column]);  // copy unrounded values
                    }
                }
            }
        }

        this.localClipboard = values;
        this.disableClear = true;
        var oldFocus = document.activeElement as HTMLInputElement;
        CellSelection.copyToClipboard(values.join('\t'));
        if (oldFocus != null) {
            oldFocus.focus();
        }
        this.disableClear = false;
    }

    public static copyToClipboard(val: string) {
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/offer-entry-grid/cellSelection.ts